import React, { useState } from 'react'
import { Container, Alert } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import { logError } from 'appinsights/appinsights'
import { AxiosError } from 'axios'
import CircleSpinner from 'components/circle-spinner/CircleSpinner'
import { appRoutes } from 'constants/routes/appRoutes'
import authenticationService from 'services/authServices'
import { getErrorWithFullMessage } from 'utils/authHelpers'

import './SignicatCallbackPage.scss'

function SignicatCallbackPage() {
	const [error, setError] = useState<Error>()
	const [isWaiting, setIsWaiting] = useState(false)
	const { t } = useTranslation()

	React.useEffect(
		() => {
			signin()
		},
		// eslint-disable-next-line
		[]
	)

	async function signin() {
		const search = window.location.search
		const params = new URLSearchParams(search)
		setIsWaiting(true)

		try {
			if (window.location.search.indexOf('error_description') !== -1) {
				const errorMsg = params.get('error_description')
				logError(
					new Error(
						`${JSON.stringify({
							errorMessage: errorMsg as string,
							params: params,
						})}]`
					)
				)
				setError(new Error(errorMsg ? errorMsg : ''))
			} else if (window.location.search.indexOf('code') > -1) {
				const authResult =
					await authenticationService.signicatResultGet(search, t)
				authenticationService.redirectTo(
					window.location.origin + appRoutes.callbackPage,
					authResult.secret
				)
			}
		} catch (error) {
			setError(getErrorWithFullMessage(error as Error | AxiosError))
		}
	}

	return (
		<Container id="signicat-callback-page" className="spinner-container">
			{error ? (
				<Alert
					variant="danger"
					dismissible
					onClose={() => (window.location.href = appRoutes.login)}>
					{error.message}
				</Alert>
			) : isWaiting ? (
				<div className="spinner-container">
					<CircleSpinner />
				</div>
			) : null}
		</Container>
	)
}

export default SignicatCallbackPage
